export enum EAppService {
  AppStore = 'AppStoreButton',
  GooglePlay = 'GooglePlayButton',
}

export const GP = {
  name: EAppService.GooglePlay,
  title: 'Google Play',
  className: 'google-btn',
  url: 'https://play.google.com/store/apps/details?id=ru.cian.main&hl=ru',
};

export const AS = {
  name: EAppService.AppStore,
  title: 'App Store',
  className: 'apple-btn',
  url: 'https://apps.apple.com/ru/app/циан-недвижимость-квартиры/id911804296',
};

export const APP_BUTTONS = {
  [EAppService.GooglePlay]: GP,
  [EAppService.AppStore]: AS,
};
